import React, { useState, useEffect } from "react";
import axios from "axios";
import getCookie from "../../api";
import axiosInstance from "../../api";
import Select from "react-select";
import moment from "moment";

function AddCustomerBoiler({ boilerindex, customerboilerdata, dispatch }) {
  const [boilerData, setBoilerData] = useState([]);
  const [boilerSeriesData, setBoilerSeriesData] = useState([]);

  const [reloadDropdown, setreloadDropdown] = useState(false);
  const [rotateBoilerHeaddropdownicon, setrotateBoilerHeaddropdownicon] =
    useState(false);
  const [rotateBoilerSeriesDropdownIcon, setRotateBoilerSeriesDropdownIcon] =
    useState(false);

  useEffect(() => {
    setrotateBoilerHeaddropdownicon(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Boiler/GetBoilerDropdown`)
      .then((res) => {
        setBoilerData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotateBoilerHeaddropdownicon(false);
      });
  }, [reloadDropdown]);

  function fetchboilerseries(boilerhead) {
    setRotateBoilerSeriesDropdownIcon(true);

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/GetBoilerSeriesByIdOrheadOrSeriesCode?Head=${boilerhead}`
      )
      .then((response) => {
        setBoilerSeriesData(response.data.data);
      })
      .catch(console.log)
      .finally(() => {
        setRotateBoilerSeriesDropdownIcon(false);
      });
  }

  useEffect(() => {
    fetchboilerseries(customerboilerdata[boilerindex]?.boilerHead);
  }, []);

  return (
    <form className="add-customer-address">
      <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
        <p>Customer Boiler</p>
        <button
          type="button"
          style={{ marginLeft: "auto" }}
          onClick={() => {
            dispatch({ type: "decrement", index: boilerindex });
          }}
        >
          <i class="fa-solid fa-circle-minus"></i>
        </button>
        <button
          type="button"
          onClick={() => {
            dispatch({ type: "increment" });
          }}
        >
          <i class="fa-solid fa-circle-plus"></i>
        </button>
      </blockquote>
      <blockquote>
        <label>
          Boiler Head{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <Select
            isSearchable
            options={boilerData}
            onChange={(values) => {
              if (values) {
                const val = values?.value;
                fetchboilerseries(val);
                dispatch({
                  type: "field",
                  index: boilerindex,
                  name: "boilerHead",
                  value: val,
                });
              }
            }}
            value={boilerData?.find(
              (x) => x?.value == customerboilerdata[boilerindex]?.boilerHead
            )}
            isClearable
            required
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            placeholder="Select Boiler Head"
            menuPlacement="top"
          />

          <i
            class={`fa-solid fa-rotate-right ${
              rotateBoilerHeaddropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() => setreloadDropdown(!reloadDropdown)}
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>
          Boiler Series{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <select
            onChange={(e) => {
              dispatch({
                type: "field",
                index: boilerindex,
                name: "boilerSeries",
                value: e.target.value,
              });
            }}
            required
          >
            <option value="">Select Boiler Series</option>
            {boilerSeriesData.map((boilerSeries, index) => (
              <option
                key={index}
                value={boilerSeries.id}
                selected={
                  boilerSeries.id ===
                  customerboilerdata[boilerindex]?.boilerSeries
                }
              >
                {boilerSeries.seriesCode}
              </option>
            ))}
          </select>
          <i
            class={`fa-solid fa-rotate-right ${
              rotateBoilerSeriesDropdownIcon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              fetchboilerseries(customerboilerdata[boilerindex]?.boilerHead)
            }
          ></i>
        </aside>
      </blockquote>
      <aside>
        <blockquote>
          <label>Purchase Date </label>
          <input
            type="date"
            placeholder="Enter Purchase Date"
            onChange={(e) => {
              dispatch({
                type: "field",
                index: boilerindex,
                name: "purchaseDate",
                value: e.target.value,
              });
            }}
            value={
              customerboilerdata[boilerindex]?.purchaseDate
                ? moment(
                    new Date(customerboilerdata[boilerindex]?.purchaseDate)
                  ).format("YYYY-MM-DD")
                : null
            }
          />
        </blockquote>
        <blockquote>
          <label>Sr. No. </label>
          <input
            type="number"
            placeholder="Enter Serial Number"
            onChange={(e) => {
              dispatch({
                type: "field",
                index: boilerindex,
                name: "srNo",
                value: e.target.value,
              });
            }}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 10);
            }}
            value={customerboilerdata[boilerindex]?.srNo}
          />
        </blockquote>
      </aside>
    </form>
  );
}

export default AddCustomerBoiler;
